import { render, staticRenderFns } from "./ArticleImportStatus.vue?vue&type=template&id=1c07cb3c&scoped=true"
import script from "./ArticleImportStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleImportStatus.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c07cb3c",
  null
  
)

export default component.exports